var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3732_1899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9336 9.85972C14.9333 10.4091 14.4879 10.8543 13.9385 10.8543H10.8561H8.86506H5.78456C5.23476 10.8543 4.78906 10.4086 4.78906 9.85878V9.85878C4.78906 9.30898 5.23476 8.86328 5.78456 8.86328H8.86606L10.8571 8.86377L13.9386 8.86416C14.4883 8.86423 14.9338 9.31001 14.9336 9.85972V9.85972Z",
    fill: "#3B71CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86 1.99091C11.6797 1.99155 13.4429 2.6231 14.8492 3.77795C16.2555 4.9328 17.2179 6.5395 17.5725 8.32435C17.927 10.1092 17.6518 11.9617 16.7936 13.5664C15.9354 15.1711 14.5475 16.4286 12.8662 17.1246C11.1849 17.8207 9.31421 17.9124 7.57291 17.3839C5.83162 16.8555 4.32741 15.7396 3.31654 14.2265C2.30568 12.7134 1.85069 10.8966 2.02911 9.08568C2.20752 7.27473 3.0083 5.58166 4.295 4.29491C5.02511 3.56351 5.89268 2.98375 6.84776 2.58902C7.80284 2.19429 8.82657 1.99237 9.86 1.99491M9.86 0.00390645C7.90988 0.00390645 6.00355 0.582185 4.38208 1.66562C2.76061 2.74905 1.49683 4.28897 0.750552 6.09065C0.00427222 7.89233 -0.190989 9.87484 0.189462 11.7875C0.569912 13.7002 1.50899 15.457 2.88793 16.836C4.26688 18.2149 6.02376 19.154 7.93641 19.5344C9.84907 19.9149 11.8316 19.7196 13.6333 18.9734C15.4349 18.2271 16.9749 16.9633 18.0583 15.3418C19.1417 13.7204 19.72 11.814 19.72 9.86391C19.7203 8.569 19.4654 7.28673 18.97 6.09034C18.4746 4.89395 17.7483 3.80689 16.8327 2.89125C15.917 1.97561 14.83 1.24934 13.6336 0.753919C12.4372 0.258501 11.1549 0.00364371 9.86 0.00390645Z",
    fill: "#3B71CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3732_1899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.72,
    height: 19.72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusBlue);
export default __webpack_public_path__ + "static/media/minus-blue.3c0532562baac7350183471364d9c64d.svg";
export { ForwardRef as ReactComponent };